/**
 * The frames with nothing to start: a rest day, and a day whose session is
 * already logged.
 *
 * Deliberately quiet. These are the two frames where the bolt cannot hand over a
 * workout, so the card reports rather than urges, and the commit zone below it
 * carries an outline rather than the sakura CTA.
 */

import type { CalmCardProps } from './StartWorkoutSheet.types';

import { Text } from '@/components/ui/primitives';

export function CalmCard({
  tone = 'accent',
  icon,
  title,
  children,
}: CalmCardProps): React.JSX.Element {
  return (
    <div
      className="flex items-start gap-3.5 rounded-lg border border-stroke-subtle bg-contrast-700 p-4"
      data-testid="start-workout-calm-card"
    >
      <div
        className={`grid h-11 w-11 flex-none place-items-center rounded-full border ${
          tone === 'success'
            ? 'border-success-400/40 bg-success-wash text-success-400'
            : 'border-stroke-accent bg-sakura-wash text-primary-300'
        }`}
      >
        {icon}
      </div>
      <div className="min-w-0 flex-1">
        {title && (
          <Text
            as="div"
            variant="body-lg"
            className="font-semibold leading-snug"
          >
            {title}
          </Text>
        )}
        {children}
      </div>
    </div>
  );
}

export default CalmCard;
